import { CreditFacilitySetupPageProps } from "features/credit-facility/setup/CreditFacilitySetupPageProps";
import { useCreditFacilityRetrieveSuspense } from "gen/endpoints/credit-facility/credit-facility";
import { useCallback } from "react";
import { useNavigate } from "react-router";
import {
  PageWizardProvider,
  PageWizardRoutes,
} from "shared/components/layout/PageWizard";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { rootRoute } from "shared/navigation/Routes";

export const CreditFacilitySetupPage: React.FC = () => {
  const { fundFamilyId, creditFacilityId } = useRequiredStringParams();

  const { data } = useCreditFacilityRetrieveSuspense(
    fundFamilyId,
    creditFacilityId,
  );
  const navigate = useNavigate();

  const exitToDraft = useCallback(() => {
    navigate(
      rootRoute({})
        .fundFamilies({})
        .fundFamily({ fundFamilyId })
        .setup({})
        .creditFacilities({})
        .creditFacility({ creditFacilityId }).$,
    );
  }, [navigate, fundFamilyId, creditFacilityId]);

  const pageProps: CreditFacilitySetupPageProps = {
    fundFamilyId,
    creditFacilityId,
    creditFacility: data,
  };

  return (
    <PageWizardProvider onExit={exitToDraft}>
      <PageWizardRoutes context={pageProps} />
    </PageWizardProvider>
  );
};
